const IMAGE_PROXY_PATH = '/image-proxy';
const IMAGE_PROXY_API_PATH = '/api/v1/image-proxy';

const getApiBaseUrl = () => {
  const baseUrl = String(import.meta.env.VITE_APP_BASE_URL || '').replace(/\/$/, '');

  if (!baseUrl) {
    return '';
  }

  return baseUrl.endsWith('/api/v1') ? baseUrl : `${baseUrl}/api/v1`;
};

export const getDynamicImageProxyUrl = (url) => {
  let imageUrl = String(url || '').trim();

  if (!imageUrl) {
    return imageUrl;
  }

  let parsedImageUrl;

  try {
    parsedImageUrl = new URL(imageUrl);
  } catch {
    return imageUrl;
  }

  if (
    parsedImageUrl.pathname.replace(/\/$/, '') === IMAGE_PROXY_API_PATH
  ) {
    const originalImageUrl = parsedImageUrl.searchParams.get('url')?.trim();

    if (!originalImageUrl) {
      return imageUrl;
    }

    try {
      imageUrl = originalImageUrl;
      parsedImageUrl = new URL(imageUrl);
    } catch {
      return imageUrl;
    }
  }

  if (!['http:', 'https:'].includes(parsedImageUrl.protocol)) {
    return imageUrl;
  }

  const apiBaseUrl = getApiBaseUrl();

  if (!apiBaseUrl) {
    return imageUrl;
  }

  let proxyUrl;

  try {
    proxyUrl = new URL(`${apiBaseUrl.replace(/\/$/, '')}${IMAGE_PROXY_PATH}`);
  } catch {
    return imageUrl;
  }

  if (
    parsedImageUrl.origin === proxyUrl.origin &&
    parsedImageUrl.pathname === proxyUrl.pathname
  ) {
    return imageUrl;
  }

  proxyUrl.searchParams.set('url', imageUrl);
  return proxyUrl.toString();
};
